// Copyright (c) 2017 Deere & Company

import * as ClaimSearchHelper from '../../../shared/services/claim-search-helper';
import React, {Component, PropTypes} from 'react';
import CheckboxFilterControlled from '../../../../shared/components/facets/checkbox-filter/controlled';
import CheckboxWithSearchFilterControlled from '../../../../shared/components/facets/checkbox-with-search-filter/controlled';
import FacetFooter from '../../../../shared/components/facets/facet-footer/index';
import Facets from '../../state/facets';
import FacetsDateRangePickerOptionsControlled from '../../../../shared/components/facets/date-range-picker-options/controlled';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {addCollectionLabels} from '../../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../../shared/services/hashmap';
import {isDealerFacetInvalid} from '../../../../shared/services/facets';
function handleDealerFilterInput(text) {

    this.actions.updateDealerAccountFacetInput(text);

}

function handleDealerAccountFacetItem(item, isSelected) {

    this.actions.updateDealerAccountFacetItem(item, isSelected);

}

function handleClaimStatusFacetItem(item, isSelected) {

    this.actions.updateClaimStatusFacetItem(item, isSelected);

}

const handleApplyFilters = (props, context) => () => {

    if (!isDealerFacetInvalid(props.facets.dealerAccountsFacet)) {

        props.actions.readAllClaims(false, context.user.privacy.showWaitingForDealerInvoice);

    }

};

function updateDateRangeFacet(dateRange) {

    this.actions.updateDateRangeFacet(dateRange);

}

function updateDateType(dateTypeKey) {

    this.actions.updateDateType(dateTypeKey, ClaimSearchHelper.getClaimFacetOptions());

}

function handleResetFilters() {

    this.props.actions.resetAllFacets(this.props.facets, this.context.user.settings.claims);

}

function toggleDealerAccountFacetItems() {

    this.actions.toggleDealerAccountFacetItems(this.facets.dealerAccountsFacet.allowedDealers);

}

function toggleClaimStatusFacetItems() {

    this.actions.toggleClaimStatusFacetItems(this.facets.claimStatusFacet.allowedStatus);

}

class AllClaimsFacets extends Component {

    state = {
        dateRangePickerExpanded: false,
        dealerLocationExpanded: false,
        statusExpanded: false
    };

    onAccordionToggle = accordionName => {

        this.setState({
            [accordionName]: !this.state[accordionName]
        });

    };

    anyFacetsOpen = () =>
        this.state.dateRangePickerExpanded || this.state.dealerLocationExpanded || this.state.statusExpanded;

    render() {

        return (
            <div className='claim-search-facets'>
                <CheckboxWithSearchFilterControlled
                    canUseDefaultFormat={true}
                    initialState={createHashMap(this.props.facets.dealerAccountsFacet.selectedDealers, 'account')}
                    isExpanded={this.state.dealerLocationExpanded}
                    list={addCollectionLabels(this.props.facets.dealerAccountsFacet.displayedDealers)}
                    minNumberOfItems={4}
                    onCheckboxListChange={this.props::handleDealerAccountFacetItem}
                    onClick={this.onAccordionToggle.bind(this, 'dealerLocationExpanded')}
                    onInputChange={this.props::handleDealerFilterInput}
                    onToggleAll={this.props::toggleDealerAccountFacetItems}
                    searchInput={this.props.facets.dealerAccountsFacet.searchInput}
                    searchPlaceholder='DEALER_LOCATION_FILTER'
                    title='DEALER_LOCATIONS'
                    valueKey={'account'}
                />
                <CheckboxFilterControlled
                    displayKey='value'
                    initialState={createHashMap(this.props.facets.claimStatusFacet.selectedClaimStatus, 'key')}
                    isExpanded={this.state.statusExpanded}
                    list={addCollectionLabels(this.props.facets.claimStatusFacet.allowedStatus, 'value')}
                    minNumberOfItems={4}
                    onChange={this.props::handleClaimStatusFacetItem}
                    onClick={this.onAccordionToggle.bind(this, 'statusExpanded')}
                    onToggleAll={this.props::toggleClaimStatusFacetItems}
                    title={'STATUS'}
                    valueKey={'key'}
                />
                <FacetsDateRangePickerOptionsControlled
                    className='claim-search-options'
                    dateFormat={this.props.dateFormat}
                    dateRange={this.props.facets.claimDateRangeFacet.dateRange}
                    isExpanded={this.state.dateRangePickerExpanded}
                    isPlaceholderTranslated={true}
                    maxDate={this.props.facets.claimDateRangeFacet.dateRange.maxDate}
                    minDate={this.props.facets.claimDateRangeFacet.dateRange.minDate}
                    onChange={this.props::updateDateType}
                    onClick={this.onAccordionToggle.bind(this, 'dateRangePickerExpanded')}
                    onDateChange={this.props::updateDateRangeFacet}
                    optionDisplayAttributes={['value']}
                    optionKey='key'
                    options={ClaimSearchHelper.getClaimFacetOptions()}
                    placeholder=''
                    selectedValue={this.props.facets.dateTypeFacet.key}
                    title={'DATE'}
                />
                {this.anyFacetsOpen() ?
                    <FacetFooter
                        disabled={isDealerFacetInvalid(this.props.facets.dealerAccountsFacet)}
                        onApply={handleApplyFilters(this.props, this.context)}
                        onReset={this::handleResetFilters}
                    /> : null}
            </div>
        );

    }

}

AllClaimsFacets.displayName = 'AllClaimsFacets';
AllClaimsFacets.propTypes = {
    actions: PropTypes.object.isRequired,
    dateFormat: PropTypes.string.isRequired,
    facets: PropTypes.instanceOf(Facets)
};
AllClaimsFacets.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};
export default AllClaimsFacets;



// WEBPACK FOOTER //
// ./src/claim/all-claims/components/all-claims-facets/all-claims-facets-container.js